import { useSnapshot } from "valtio/react";
import { useQuery } from "@apollo/client";
import { siteStore } from "src/js/stores/site/store";
import { routedClient } from "react-migration/lib/persistence/apollo/routedClient";
import { CreateSitesDryRunResponse } from "../typings/CreateSitesDryRunRespone";
import CREATE_SITES_DRY_RUN from "../graphql/createSitesDryRun.gql";
import { Site } from "../typings/Site";

type useCreateSitesDryRunQueryParams = {
  shouldWait?: boolean;
  sites: Site[];
  onCompleted?: (value: CreateSitesDryRunResponse) => void;
  siteMatchType?: "EXACT" | "INTERSECTS_POINT";
};

export const useCreateSitesDryRunQuery = (args: useCreateSitesDryRunQueryParams) => {
  const { selectedWorkspaceId } = useSnapshot(siteStore);

  return useQuery<CreateSitesDryRunResponse>(CREATE_SITES_DRY_RUN, {
    client: routedClient,
    variables: {
      sites: args.sites,
      siteMatchType: args.siteMatchType,
      workspaceId: selectedWorkspaceId,
    },
    fetchPolicy: "network-only",
    onCompleted: args.onCompleted,
    skip: args.shouldWait,
  });
};
